
export default {
  name: 'TrashIcon',
};
